import BaseModelAPI from '../BaseModelAPI';

export default class Machine extends BaseModelAPI {
	static entity = 'machine';
	static entityName = 'machine';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.tonase = 0;
			this.productionControlTimeId = '';
			this.productionControlTime = {};
			this.sph = 0;
			this.lineCodeId = '';
			this.lineCode = {};
			this.remark = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}